import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';

export const Modal = bootstrap.Modal;
export const Tooltip = bootstrap.Tooltip;
export const Dropdown = bootstrap.Dropdown;

export type ModalInstance = InstanceType<typeof Modal>;
export type TooltipInstance = InstanceType<typeof Tooltip>;
export type DropdownInstance = InstanceType<typeof Dropdown>;
